/**
 * Orders candidate batches by distance from the viewport center, nearest
 * first. Used when concurrency is limited and we need to pick which of the
 * pending candidates to fetch next — items closest to what the user is
 * actually looking at should load first.
 */
export function rankByViewportDistance(
  candidates: number[],
  batches: readonly number[][],
  visibleItems: Set<number>
): number[] {
  const visibleArray = [...visibleItems].sort((a, b) => a - b)
  const center = visibleArray[Math.floor(visibleArray.length / 2)]

  return [...candidates]
    .map((batchIdx) => {
      const minDist = Math.min(
        ...batches[batchIdx].map((i) => Math.abs(i - center))
      )
      return { batchIdx, minDist }
    })
    .sort((a, b) => a.minDist - b.minDist)
    .map((entry) => entry.batchIdx)
}
